export const ConvertToPlayModal = () => import("@clubs/components/modals/ConvertToPlayModal.vue");

export default { ConvertToPlayModal };
